import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

interface Props {
    icon: React.ReactNode;
    value?: string | null;
    fallbackText?: string;
}

export const LeadSidebarRowItem = (props: Props) => {
    if (!props.value && !props.fallbackText) {
        return null;
    }

    return (
        <Stack isHorizontal={true} spacing={4} alignItems='center'>
            {props.icon}
            <Body size='small' color='medium' truncate={{type: 'inline'}}>
                {props.value || props.fallbackText}
            </Body>
        </Stack>
    );
};
